import type { TrackEventName, TrackPayload } from '../types/tracking'

const TRACK_ENDPOINT = '/api/track'

export function sendTrackEvent(
  event: TrackEventName,
  properties: Record<string, string | number | boolean>,
  options?: { beacon?: boolean }
): void {
  if (typeof window === 'undefined') return

  const heap = (window as any).heap
  const payload: TrackPayload = {
    event,
    properties,
    heapSessionId: heap?.getSessionId?.() ?? undefined,
    heapUserId: heap?.userId?.() ?? undefined
  }

  const body = JSON.stringify(payload)
  console.log('[debug] ', body)
  if (
    options?.beacon &&
    typeof navigator !== 'undefined' &&
    navigator.sendBeacon
  ) {
    navigator.sendBeacon(
      TRACK_ENDPOINT,
      new Blob([body], { type: 'application/json' })
    )
    return
  }

  fetch(TRACK_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true
  }).catch(() => {})
}
